import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { DIRECT_CONTENT, INDIRECT_CONTENT } from './utils';
import styles from './style.css';
import { modalCloseHandler, modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';

const LearnMoreModal = () => {
  const { next, appState, closeNextModal } = useContext(FlowContext);
  const ROLLOVER_TYPE = appState?.result;
  const CONTENT = {
    DIRECT: DIRECT_CONTENT,
    INDIRECT: INDIRECT_CONTENT
  }[ROLLOVER_TYPE];

  return (
    <>
      <MFBeaconModal open removeCloseButton>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            id="learnMoreModalCloseIcon"
            data-name="learnMoreModalCloseIcon"
            variant="tertiary"
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">{CONTENT?.title}</div>
        <div className="beacon-modal__description">
          <span>
            <ul>
              {CONTENT?.body?.map(bulletItem => (
                <li key={bulletItem.id}>{bulletItem.disc}</li>
              ))}
            </ul>
          </span>
        </div>
        <div slot="action-zone" className="learn-more-btn-container">
          <MFBeaconButton
            noButtonMargin
            variant="tertiary"
            id="learnMoreModalClose"
            data-name="learnMoreModalClose"
            type="button"
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            label="Cancel"
          />
          <MFBeaconButton
            noButtonMargin
            type="button"
            variant="primary"
            id="learnMoreModalChooseBtn"
            data-name="learnMoreModalChooseBtn"
            onClick={() => {
              modalCloseHandler();
              next(ROLLOVER_TYPE)();
            }}
            label="Choose this option"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default LearnMoreModal;
